import { render } from "./ImageSizeSelectActual.vue?vue&type=template&id=08ee420c"
import script from "./ImageSizeSelectActual.vue?vue&type=script&lang=js"
export * from "./ImageSizeSelectActual.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ImageSizeSelectActual.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08ee420c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08ee420c', __exports__)) {
    api.reload('08ee420c', __exports__)
  }
  
  module.hot.accept("./ImageSizeSelectActual.vue?vue&type=template&id=08ee420c", () => {
    api.rerender('08ee420c', render)
  })

}


export default __exports__